import { Checkbox, ListItemText, MenuItem } from '@mui/material';
import type { MenuItemProps } from '@mui/material';
import type { ReactNode } from 'react';

type CheckboxMenuItemProps = {
    checked: boolean;
    label: ReactNode;
} & Omit<MenuItemProps, 'children'>;

/**
 * Multi-select menu item. The item itself carries the menuitemcheckbox role
 * and checked state; the Checkbox is visual only (hidden from assistive
 * technology, out of tab order, and transparent to the pointer so a click on
 * the glyph lands on the item). Rest props are forwarded so MUI's MenuList
 * keyboard navigation keeps working.
 */
export default function CheckboxMenuItem({
    checked,
    label,
    ...other
}: CheckboxMenuItemProps) {
    return (
        <MenuItem
            dense
            role="menuitemcheckbox"
            aria-checked={checked}
            {...other}
        >
            <Checkbox
                size="small"
                checked={checked}
                tabIndex={-1}
                disableRipple
                inputProps={{ 'aria-hidden': true }}
                sx={{ p: 0.5, mr: 1, pointerEvents: 'none' }}
            />
            <ListItemText primaryTypographyProps={{ fontSize: 12 }}>
                {label}
            </ListItemText>
        </MenuItem>
    );
}
